export const ABTests = {
  oldOrNewLP: {
    variations: [
      { key: "old", description: "LP antiga" },
      { key: "new", description: "LP nova" },
    ],
    dev: {
      version: 4,
      variationsWeights: [50, 50],
    },
    sit: {
      version: 1,
      variationsWeights: [90, 10],
    },
    uat: {
      version: 1,
      variationsWeights: [90, 10],
    },
    prod: {
      version: 1,
      variationsWeights: [90, 10],
    },
  },
};
